import * as React from "react";
import { FieldProps } from "formik";
import { Form, Input, InputNumber } from "antd";
import { useState, useRef } from "react";

const FormItem = Form.Item;

export const InputField: React.FC<
  FieldProps<any> & {
    description?: string;
    prefix: React.ReactNode;
    label?: string;
    useNumberComponent?: boolean;
    className?: string;
    pinLength?: number;
    otpLength?: number;
    disabled?: boolean;
    autoFocus?: boolean;
  }
> = ({
  field: { onChange, ...field },
  form: { touched, errors, setFieldValue, setFieldTouched },
  label,
  useNumberComponent = false,
  className = "",
  pinLength = 4,
  otpLength = 6,
  disabled = false,
  autoFocus = true,
  description,
  ...props
}) => {
  const [rawAmount, setRawAmount] = useState<string>("");
  const otpInputRefs = useRef<(HTMLInputElement | null)[]>(new Array(otpLength).fill(null));

  const errorMsg = touched[field.name] && errors[field.name];
  const Comp: any = useNumberComponent ? InputNumber : Input;

  // Auto-focus for OTP
  React.useEffect(() => {
    if (field.name === "otpPin" && autoFocus && otpInputRefs.current[0]) {
      otpInputRefs.current[0].focus();
    }
  }, [autoFocus, field.name]);

  // Default classes
  const defaultClasses =
    "h-[3rem] text-[#fff] w-full !rounded-lg !border-none !text-white appearance-none px-4 py-3 !bg-[#1E1E1E] backdrop-blur-sm text-white/90 placeholder:text-white/40 focus:outline-none shadow-lg transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed";

  // Merge default and custom classes
  const mergedClassName = `${defaultClasses} ${className}`.trim();

  return (
    <>
      {field.name === "amount" ? (
        <div className="w-full">
          <input
            {...field}
            {...Object.fromEntries(Object.entries(props).filter(([key]) => key !== "prefix"))}
            type="text"
            disabled={disabled}
            value={
              rawAmount
                ? `₦${rawAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                : "₦"
            }
            onChange={(e) => {
              let value = e.target.value.replace(/^₦/, "").replace(/,/g, "");
              value = value.replace(/[^\d]/g, "");
              setRawAmount(value);
              setFieldValue(field.name, value);
            }}
            className="w-full bg-transparent focus:outline-none focus:border-none text-white text-center text-2xl font-medium"
            placeholder="₦0"
            style={{ backgroundColor: "transparent", border: "none", boxShadow: "none" }}
          />
          {errorMsg && <div className="text-red-500 text-sm mt-1">{typeof errorMsg === 'string' ? errorMsg : JSON.stringify(errorMsg)}</div>}
        </div>
      ) : (
        <FormItem
          label={label}
          help={typeof errorMsg === 'string' ? errorMsg : JSON.stringify(errorMsg)}
          validateStatus={errorMsg ? "error" : undefined}
        >
          {field.name === "password" ||
          field.name === "confirmPassword" || 
          field.name === "confirmNewPassword" ||
          field.name === "newPassword" ? (
            <Input.Password
              {...field}
              {...props}
              className={mergedClassName}
              onChange={
                useNumberComponent
                  ? (newValue: any) => setFieldValue(field.name, newValue)
                  : onChange
              }
            />
          ) : (
            <Comp
              {...field}
              {...props}
              disabled={disabled}
              className={mergedClassName}
              onChange={
                useNumberComponent
                  ? (newValue: any) => setFieldValue(field.name, newValue)
                  : onChange
              }
            />
          )}
        </FormItem>
      )}
    </>
  );
};
